import { render, staticRenderFns } from "./InterestRateList.vue?vue&type=template&id=af10062a&scoped=true"
import script from "./InterestRateList.vue?vue&type=script&lang=js"
export * from "./InterestRateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af10062a",
  null
  
)

export default component.exports